module.exports = __webpack_public_path__ + "img/side-icon3.8631f477.svg";